export enum TaskType {
  CALL = 'CALL',
  EMAIL = 'EMAIL',
  MEETING = 'MEETING',
  TODO = 'TODO',
  FOLLOW_UP = 'FOLLOW_UP',
  CUSTOM = 'CUSTOM',
}

export enum TaskStatus {
  NOT_STARTED = 'NOT_STARTED',
  TODO = 'TODO',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  DEFERRED = 'DEFERRED',
  OVERDUE = 'OVERDUE',
}

export enum TaskPriority {
  LOW = 'LOW',
  NORMAL = 'NORMAL',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  URGENT = 'URGENT',
}

export enum ReminderChannel {
  IN_APP = 'IN_APP',
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
}

export interface TaskAssignment {
  id: number;
  taskId: number;
  userId: number;
  isPrimary: boolean;
  user: {
    id: number;
    email: string;
    firstName?: string;
    lastName?: string;
  };
}

export interface TaskAssociation {
  id: number;
  taskId: number;
  recordType: string;
  recordId: number;
  isPrimary: boolean;
}

export interface TaskReminder {
  id: number;
  taskId: number;
  triggerAt: string;
  channel: ReminderChannel;
  status: string;
}

export interface TaskComment {
  id: number;
  taskId: number;
  authorId: number;
  body: string;
  isInternal: boolean;
  createdAt: string;
  author: {
    id: number;
    email: string;
    firstName?: string;
    lastName?: string;
  };
}

export interface Task {
  id: number;
  title: string;
  description?: string;
  type: TaskType;
  status: TaskStatus;
  priority: TaskPriority;
  dueDateTime?: string;
  queueId?: number;
  source?: string;
  visibility: string;
  tags: string[];
  customFields?: any;
  outcome?: string;
  creatorId: number;
  createdAt: string;
  updatedAt: string;
  completedAt?: string;

  // Many-to-many relations
  taskClients?: {
    id: number;
    taskId: number;
    clientId: number;
    client: {
      id: number;
      name: string;
      email?: string;
      phoneNumbers?: string[];
    };
  }[];

  taskDeals?: {
    id: number;
    taskId: number;
    dealId: number;
    deal: {
      id: number;
      description: string;
      amount: number;
      currency: string;
      client?: {
        id: number;
        name: string;
      };
    };
  }[];

  creator: {
    id: number;
    email: string;
    firstName?: string;
    lastName?: string;
  };
  queue?: {
    id: number;
    name: string;
  };
  assignments: TaskAssignment[];
  associations: TaskAssociation[];
  reminders?: TaskReminder[];
  comments?: TaskComment[];
  _count?: {
    comments: number;
    reminders: number;
  };
}

export interface TaskQueue {
  id: number;
  name: string;
  description?: string;
  filters?: any;
  isActive: boolean;
  order: number;
  createdAt: string;
  updatedAt: string;
  _count?: {
    tasks: number;
  };
}

export interface TaskFilterParams {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  status?: TaskStatus;
  type?: TaskType;
  priority?: TaskPriority;
  assignedUserId?: number;
  creatorId?: number;
  queueId?: number;
  dueDateFrom?: string;
  dueDateTo?: string;
  search?: string;
  clientId?: number;
  dealId?: number;
  recordType?: string;
  recordId?: number;
  tags?: string[];
}

export interface TaskAnalytics {
  total: number;
  completed: number;
  inProgress: number;
  overdue: number;
  byType: Array<{ type: TaskType; _count: number }>;
  byPriority: Array<{ priority: TaskPriority; _count: number }>;
  completionRate: number;
}

